"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmoothImage = void 0;
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var __1 = require("../");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('status', 'setStatus', 'LOADING'), (0, recompose_1.withState)('reference', 'setReference', null), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        if (this.props.reference !== null) {
            this.props.reference.onload = null;
            this.props.reference.onerror = null;
        }
    },
    componentWillReceiveProps: function (nextProps) {
        if ((this.props.src !== nextProps.src ||
            this.props.reference !== nextProps.reference) &&
            nextProps.reference !== null) {
            var src = nextProps.src;
            nextProps.setStatus('LOADING');
            nextProps.onStatus && nextProps.onStatus('LOADING');
            nextProps.reference.onload = function () {
                nextProps.onStatus && nextProps.onStatus('LOADED');
                nextProps.setStatus('LOADED');
                if (nextProps.onComplete) {
                    nextProps.onComplete();
                }
            };
            nextProps.reference.onerror = function () {
                nextProps.onStatus && nextProps.onStatus('FAILURE');
                nextProps.setStatus('FAILURE');
                if (nextProps.onError) {
                    nextProps.onError();
                }
            };
            nextProps.reference.src = src + '?_=' + new Date().getTime();
        }
    }
}), recompose_1.pure);
exports.SmoothImage = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("img", { ref: props.setReference, className: classNames('sok-smooth-image', props.className, props.status !== 'LOADED' && 'hidden', {
            loaded: props.status === 'LOADED'
        }) }),
    React.createElement("span", { className: classNames('sok-smooth-image', props.className, 'failure', props.status !== 'FAILURE' && 'hidden') },
        React.createElement(__1.Icon, { className: 'fa-file-image', prefix: 'far' }),
        React.createElement("span", null, "There was a error while loading image")))); });
//# sourceMappingURL=index.js.map